import { Component, inject } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ModalComponent } from "../modal.component";
import { ModalService } from "src/app/shared/data-access/modal.service";

@Component({
  selector: "app-in-progress-modal",
  standalone: true,
  imports: [CommonModule, ModalComponent],
  template: `
    <app-modal modalId="inProgressModal" (closeModal)="closeModal()">
      <ng-container>
        <div
          class="content-container d-flex justify-content-center align-items-center"
        >
          <div class="feature-unavailable">
            <div class="feature-header">
              <div class="icon-wrapper">
                <svg class="warning-icon" viewBox="0 0 24 24">
                  <path
                    d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm-1-7v2h2v-2h-2zm0-8v6h2V7h-2z"
                  />
                </svg>
              </div>
              <h2 class="feature-title">Funktion noch nicht verfügbar</h2>
            </div>

            <div class="feature-message">
              Diese Funktion ist zur Zeit noch nicht verfügbar.
            </div>

            <div style="text-align: right;">
              <button class="feature-button" (click)="closeModal()">
                Okay
              </button>
            </div>
          </div>
        </div>
      </ng-container>
    </app-modal>
  `,
  styles: [
    `
      .feature-unavailable {
        padding: 24px;
      }

      .feature-header {
        display: flex;
        align-items: center;
        gap: 16px;
        margin-bottom: 16px;
      }

      .icon-wrapper {
        background-color: #fff3dc;
        border-radius: 50%;
        padding: 8px;
      }

      .warning-icon {
        width: 24px;
        height: 24px;
        fill: #f59e0b;
      }

      .feature-title {
        font-size: 20px;
        font-weight: 600;
        color: #1f2937;
        margin: 0;
      }

      .feature-message {
        color: #4b5563;
        line-height: 1.5;
        margin-bottom: 24px;
      }

      .feature-button {
        background-color: #1f2937;
        color: white;
        border: none;
        padding: 8px 16px;
        border-radius: 6px;
        cursor: pointer;
        font-size: 14px;
      }
    `,
  ],
})
export class InProgressModalComponent {
  modalService = inject(ModalService);

  openModal() {
    this.modalService.openModal("inProgressModal");
  }

  closeModal() {
    this.modalService.closeModal("inProgressModal");
  }
}
